/**
 * Phone usage of one billing period (Prompt 2.10): minutes per meter and one
 * line per number-month charged. Shown on Plan & billing.
 */
import { get } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export interface PhoneUsageMeterLine {
  meterCode: string;
  quantity: number;
  amountUsd: number;
}

export interface PhoneNumberUsageLine {
  phoneNumberId: string;
  e164: string | null;
  label: string | null;
  meterCode: string;
  kind: 'purchase' | 'renewal';
  amountUsd: number;
  included: boolean;
  at: string;
}

export interface TenantPhoneUsage {
  period: string;
  meters: PhoneUsageMeterLine[];
  numbers: PhoneNumberUsageLine[];
  totalUsd: number;
}

export interface PhonePlanMeter {
  code: string;
  label: string;
  unit: string;
  description: string | null;
  unitPriceUsd: number;
  includedQty: number;
  includedRemaining: number;
  usedQty: number;
}

/** The plan's phone terms + this month's use (Prompt 2.11). */
export interface PhonePlanSummary {
  enforced: boolean;
  planKey: string | null;
  planName: string | null;
  inboundCalls: boolean;
  limits: { maxPhoneNumbers: number | null; maxConcurrentCalls: number | null };
  numbersHeld: number;
  byoConnected: boolean;
  period: string;
  meters: PhonePlanMeter[];
}

export const phoneUsageService = {
  plan(): Promise<PhonePlanSummary> {
    return get<PhonePlanSummary>(endpoints.telephony.usagePlan);
  },

  get(period?: string): Promise<TenantPhoneUsage> {
    return get<TenantPhoneUsage>(endpoints.telephony.usage, {
      params: period ? { period } : {},
    });
  },
} as const;
